// extracted by mini-css-extract-plugin
export default {"containerStyles":"project-cancellation-form_containerStyles__oDB95"};